import { createFileRoute } from '@tanstack/react-router';
import { AccountingPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/accounting')({
  component: AccountingRoute,
});

function AccountingRoute() {
  const { orgId } = Route.useParams();
  return <AccountingPage orgId={orgId} />;
}
